import { createContext } from "react";
import { TimeEntry } from "@/services/timeTracking";

interface TimeTrackingContextType {
  runningEntry: TimeEntry | null;
  loading: boolean;
  error: string | null;
  startTimeEntry: (input: {
    description: string;
    projectId?: string;
    tags?: string[];
    location?: string;
    timezone?: string;
  }) => Promise<{ timeEntry: TimeEntry; message: string }>;
  stopTimeEntry: (
    id: string
  ) => Promise<{ timeEntry: TimeEntry; message: string }>;
  updateTimeEntry: (
    id: string,
    updates: {
      description?: string;
      startTime?: string;
      endTime?: string;
      projectId?: string;
      tags?: string[];
      location?: string;
    }
  ) => Promise<{ timeEntry: TimeEntry; message: string }>;
  deleteTimeEntry: (id: string) => Promise<void>;
  loadRunningEntry: () => Promise<void>;
  getCurrentDuration: (entry: TimeEntry) => number;
  getLiveDuration: (entry: TimeEntry) => number;
  formatDuration: (seconds: number) => string;
  createTimeEntry: (input: {
    description: string;
    projectId?: string;
    startTime?: string;
    tags?: string[];
    location?: string;
    timezone?: string;
    endTime: string;
  }) => Promise<{ timeEntry: TimeEntry; message: string }>;
  resumeTimeEntry: (entry: TimeEntry, preferredTimezone?: string | null) => Promise<{ timeEntry: TimeEntry; message: string }>;
}

export const TimeTrackingContext = createContext<
  TimeTrackingContextType | undefined
>(undefined);

export type { TimeTrackingContextType };
